import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import SearchSource from '~/constants/SearchSource';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';
import ArrowBackDouble from '~/icons/ArrowBackDouble';
import ArrowForwardDouble from '~/icons/ArrowForwardDouble';
import {
  ArrowBack,
  ArrowForward,
  ListItem,
  NavButton,
  OuterButtonNext,
  OuterButtonBack,
  PaginationText,
  PaginationWrapper
} from './pagination.styles';
import { usePagination } from '../hooks';

const Pagination = () => {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { pagination: currentPagination, updatePagination } = usePagination();
  const { currentPage = 1, totalMatchedPages } = currentPagination;

  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalMatchedPages;

  return (
    <PaginationWrapper
      className="px-0"
      data-qa="pagination-wrapper"
      id="pagination"
    >
      <ListItem>
        <OuterButtonBack
          disabled={isFirstPage}
          onClick={() => {
            trackEvent('Pagination - clicked', {
              controlType: 'firstPage',
              page: 1
            });
            updatePagination('start');
            setSearchSource(SearchSource.Pagination);
          }}
          data-cv-test="Cv.Search.Pagination.FirstPageButton"
        >
          <ArrowBackDouble />
        </OuterButtonBack>
        <NavButton
          disabled={isFirstPage}
          onClick={() => {
            trackEvent('Pagination - clicked', {
              controlType: 'previousPage',
              page: currentPage - 1
            });
            updatePagination('subtract');
            setSearchSource(SearchSource.Pagination);
          }}
          data-cv-test="Cv.Search.Pagination.PreviousPageButton"
        >
          <ArrowBack />
          <span className="hidden m:inline">Back</span>
        </NavButton>
      </ListItem>
      <ListItem>
        <PaginationText data-cv-test="Cv.Search.Pagination.CurrentPageDisplay">
          {`Page ${currentPage} of ${totalMatchedPages}`}
        </PaginationText>
      </ListItem>
      <ListItem>
        <NavButton
          disabled={isLastPage}
          onClick={() => {
            trackEvent('Pagination - clicked', {
              controlType: 'nextPage',
              page: currentPage + 1
            });
            updatePagination('add');
            setSearchSource(SearchSource.Pagination);
          }}
          data-cv-test="Cv.Search.Pagination.NextPageButton"
        >
          <span className="hidden m:inline">Next</span>
          <ArrowForward />
        </NavButton>
        <OuterButtonNext
          disabled={isLastPage}
          onClick={() => {
            trackEvent('Pagination - clicked', {
              controlType: 'lastPage',
              page: totalMatchedPages
            });
            updatePagination('end');
            setSearchSource(SearchSource.Pagination);
          }}
          data-cv-test="Cv.Search.Pagination.LastPageButton"
        >
          <ArrowForwardDouble />
        </OuterButtonNext>
      </ListItem>
    </PaginationWrapper>
  );
};

export default Pagination;
